<template>
  <div
    :class="{'aside-is-collapsed': collapse}"
    class="flex flex-col h-full">
      <news-bar />
      <header-core />
      <main class="flex h-full overflow-hidden relative">
        <div class="absolute left-0 bottom-0 z-50 lg:hidden">
          <div class="pl-4 py-2 md:py-1">
            <base-button-icon
              @click="toogleAside"
              name="hamburguer" mode="primary-phantom" size="xl" 
              titleIcon="Desplegar menú de navegación y opciones"
              ariaLabel="Desplegar menú de navegación y opciones"
              />
          </div>
        </div>
        <aside-core :isOpen="aside" @toggle="asideBehaviour" @toogleAside="toogleAside"/>
        <router-view />
        <transition name="fade">
          <div class="fixed right-6 bottom-12 z-chatbot" v-if="showButtonChatbot">
            <div class="pl-4 py-2 md:py-1">
              <button 
                type="button"
                id="buttonchatbot"
                class="cursor-pointer rounded-full bg-white shadow-xl/30 shadow-secondary border-2 border-secondary-400"
                :style="darkMode ? 'box-shadow: var(--secondary-900) 3px 3px 10px 0px;' : 'box-shadow: var(--secondary-400) 3px 3px 10px 0px;'"
                @click="toggleChatbot"
              >
                <base-logo
                  filename="Z3RO_2.png"
                  class="brand p-2 max-w-xs max-h-20"
                  alt="Chatbot"
                />
              </button>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="fixed right-4 bottom-[6.5rem] z-chatbot-close" v-if="showButtonChatbot">
            <div class="pl-4 py-2 md:py-1">
              <base-button-icon
                  @click="() => this.$store.commit('app/setshowButtonChatbot', false)"
                  ariaLabel="Cerrar Chatbot"
                  name="cross"
                  mode="secondary"
                  size="xs"
                  iconSize="xsm"
                />
            </div>
          </div>
        </transition>
      </main>
      <chat-panel
        :panelOpen="showModalChatbot"
        @togglePanel="toggleChatbot"
      />
  </div>
</template>
<script>
import HeaderCore from '@/components/HeaderCore.vue'
import AsideCore from '@/components/AsideCore.vue'
import ChatPanel from '@/components/ia/ChatPanel.vue'
import NewsBar from '@/components/NewsBar.vue'
import { isAiEnabled } from '@/config/runtimeConfig'

export default {
  name: 'private-home',
  components: {
    HeaderCore,
    AsideCore,
    ChatPanel,
    NewsBar,
  },
  mounted () {
    setTimeout(() => {
      if (isAiEnabled()) {
        this.$store.commit('app/setshowButtonChatbot', true)
      }
    }, 1000)
  },
  data: function () {
    return {
      aside: false,
      collapse: false,
      // Chat bot
      showModalChatbot: false,
    }
  },
  computed: {
    showButtonChatbot: function () {
      return this.$store.getters['app/showButtonChatbot']
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
  },
  methods: {
    updateshowButtonChatbot () {

    },
    toggleChatbot: function () {
      this.showModalChatbot = !this.showModalChatbot
      this.showButtonChatbot = this.$store.commit('app/setshowButtonChatbot', !this.showButtonChatbot)
    },
    toogleAside: function () {
      this.aside = !this.aside
    },
    asideBehaviour: function (res) {
      this.aside = res.aside
      this.collapse = res.collapse
    }
  }
}
</script>

<style lang="scss" scoped>
#buttonchatbot {
  &:active {
    transform: scale(0.9);
  }
}
</style>
